export enum SiteRole {
  User,
  SiteAdministrator,
  TrainingCoordinator,
  Observer
}
